import Vue from 'vue';
import normalize from 'normalize.css';
import VeeValidate, { Validator } from 'vee-validate';
import 'v-toaster/dist/v-toaster.css';
import attributesPtBr from 'vee-validate/dist/locale/pt_BR';
import attributesEn from 'vee-validate/dist/locale/en';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown,
  faUser,
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
  faInfoCircle,
  faCreditCard,
  faBarcode,
  faCalendarDay,
  faThumbsUp,
  faSpinner,
  faExclamationTriangle,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Toaster from 'v-toaster';
import masker from 'vue-the-mask/src/masker';
import tokens from 'vue-the-mask/src/tokens';
import router from './router/index';
import App from './App.vue';

const mask = (value, str) => masker(value, str, true, tokens);

Validator.localize('pt_BR', attributesPtBr);

Validator.extend('fullname', {
  getMessage: () => `É necessário o preenchimento de nome e sobrenome`,
  validate: value => /(\w.+\s).+/i.test(value)
});

Validator.extend('creditcard', {
  getMessage: () => `Cartão inválido`,
  validate: value => window.Iugu.utils.validateCreditCardNumber(value)
});

Vue.use(VeeValidate, {
  locale: 'pt_BR',
  errorBagName: 'vErrors',
  dictionary: {
    translationsEn: {
      attributes: attributesEn
    },
    translationsPt: {
      attributes: attributesPtBr
    }
  }
});

// Mask filters
Vue.filter('mask', mask);
Vue.filter('tel', tel => mask(tel, '(##) ####-####'));
Vue.filter('mobile', mobile => mask(mobile, '(##) #####-####'));
Vue.filter('cep', cep => mask(cep, '#####-###'));
Vue.filter('cpf', cpf => mask(cpf, '###.###.###-##'));
Vue.filter('rg', rg => mask(rg, '##.###.###-X'));

// Icons

library.add(
  faCaretDown,
  faUser,
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
  faInfoCircle,
  faCreditCard,
  faBarcode,
  faCalendarDay,
  faThumbsUp,
  faSpinner,
  faExclamationTriangle,
  faTimes
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// Toaster

Vue.use(Toaster, {
  timeout: 5000
});

Vue.config.productionTip = false;
if (process.env.VUE_APP_ENV !== 'production') {
  Vue.config.devtools = true;
}

new Vue({
  router,
  normalize,
  render: h => h(App)
}).$mount('#app');
